import React from 'react';
import { Redirect } from 'react-router-dom';
import { useObservable } from 'react-use-observable';

import { Col, Row, Spin } from 'antd';

import { ACCOUNTS_CONNECT_TOKEN, ACCOUNTS_ENV } from 'settings';
import TopPage from 'v2/components/Shared/TopPage';
import eduzzAccountsService from 'v2/services/eduzzAccount';

const ConnectEduzz = React.lazy(() => import('@eduzz/connect'));

export const Connect = () => {
  const [user] = useObservable(() => eduzzAccountsService.getUser(), []);
  const [loadingBetaModules] = useObservable(() => eduzzAccountsService.getLoadingBetaModules(), []);
  const [permissions] = useObservable(() => eduzzAccountsService.getPermissions(), []);
  const isBetaNewConnect = eduzzAccountsService.verifyUserHasBetaModule('new_connect');
  const isOwner = permissions?.owned;

  if (!user) return null;

  if (loadingBetaModules)
    return (
      <div className='flex items-center justify-center p-8'>
        <Spin />
      </div>
    );

  if ((!isOwner || !isBetaNewConnect) && !user.is_support) return <Redirect to='/producer/connect' />;

  return (
    <div className='animate-fadeIn'>
      <style>
        {`
            #main-content {
              max-width: calc(944px + 3rem);
              margin: 0 auto;
            }
          `}
      </style>
      <TopPage title='Connect' />

      <Row>
        <Col span={24}>
          <React.Suspense fallback={<Spin />}>
            <ConnectEduzz
              application='orbita'
              env={ACCOUNTS_ENV}
              accounts_partner={ACCOUNTS_CONNECT_TOKEN}
              user_id={user.id}
            ></ConnectEduzz>
          </React.Suspense>
        </Col>
      </Row>
    </div>
  );
};
